import { IUserProfileRes } from '@/interface/account/IGetUserProfile';
import { client } from '@/modules/HttpClient';

/**
 * 获取用户登录信息
 */
export const  getUserProfile = async (): Promise<IUserProfileRes> => {
    const res = await client.get<IUserProfileRes>('/session/profile/?lang=en&no-mobile-redirection=1');
    return res;
};
